import React from 'react';
import clsx from 'clsx';
import Button from '@components/Button';
import WalletIcon from '@components/WalletIcon';

import useScreen, { Screen } from '@hooks/useScreen';
import { WalletType } from '@types';
import { shortenAddress } from '@lib/utils';

export interface WalletAddressWithConnectSecondWalletButtonProps {
  className?: string;
  hasShadow?: boolean;
  onConnectSecondWallet: (e: React.MouseEvent<HTMLButtonElement>) => void;
  textClassName?: string;
  walletAddress: string;
  size?: 'small' | 'medium';
}

const WalletAddressWithConnectSecondWalletButton = ({
  className,
  hasShadow = true,
  onConnectSecondWallet,
  size = 'small',
  textClassName,
  walletAddress,
}: WalletAddressWithConnectSecondWalletButtonProps) => {
  const { screen } = useScreen();

  return (
    <div
      className={clsx(
        'flex bg-black items-center p-2 rounded-small shadow-default',
        className
      )}
    >
      <WalletIcon
        variant={WalletType.deficonnect}
        className={clsx('mr-1', {
          'text-heading4': size === 'small',
          'text-heading3': size === 'medium',
        })}
        idPrefix="wallet-address"
      />
      <div
        className={clsx(
          'font-semibold mr-auto',
          {
            'text-gray': hasShadow === true,
            'text-white': hasShadow === false,
          },
          { 'text-heading5': size === 'medium' },
          textClassName
        )}
        data-testid="wallet-address-input"
      >
        {shortenAddress(walletAddress)}
      </div>
      {screen && screen >= Screen.desktop && (
        <>
          <div className="text-white text-smallSemibold font-semibold px-3">
            or
          </div>
          <Button
            size="micro"
            variant="inverted"
            onClick={onConnectSecondWallet}
            data-testid="connect-second-wallet-button"
          >
            Connect Second Wallet
          </Button>
        </>
      )}
    </div>
  );
};

export default WalletAddressWithConnectSecondWalletButton;
